import SwitchComponent from "./Switch";
export default SwitchComponent;